import { Routes, Route } from "react-router-dom";

import Ships from "./Ships";
import ShipCreateEdit from "./ShipCreateEdit";
import ShipDetails from "./ShipDetails";
import ShipEvents from "./ShipEvents";

const index = () => {
	return (
		<Routes>
			<Route index element={<Ships />} />
			<Route path='/create' element={<ShipCreateEdit />} />
			<Route path='/:id/edit' element={<ShipCreateEdit />} />
			<Route path='/:id/details' element={<ShipDetails />} />
			<Route path='/events' element={<ShipEvents />} />
		</Routes>
	);
};

export default index;
